/**
 * ⚠️ Make sure this object stays in sync with
 * Nuxt's constants urls.js file!
 **/
export default Object.freeze({
  // tool pages for iframe
  includeAppointmentTool: '/includes/tools/afspraak-maken',
  includeInterestCompareTool: '/includes/tools/rentevergelijker',
  includeMaxMortgageTool: '/includes/tools/maximale-hypotheek',
  includeMaxMortgageToolIntake: '/includes/tools/maximale-hypotheek-intake',
  includeMaxMortgageToolInline: '/includes/tools/maximale-hypotheek-inline',
  includeMonthlyExpensesTool: '/includes/tools/maandlasten',
  includeRateAveragingTool: '/includes/tools/rentemiddelen',
  includeRefinanceTool: '/includes/tools/oversluiten',

  // result/feedback pages for iframe
  includeMaxMortgageResult: '/includes/results/maximale-hypotheek',
  includeMaxMortgageResultIntake: '/includes/results/maximale-hypotheek-intake',
  includeMaxMortgageEntrepreneurResult: '/includes/results/hypotheek-zzp',
  includeRefinanceResult: '/includes/results/hypotheek-oversluiten',
  includeIncreaseResult: '/includes/results/hypotheek-verhogen',

  // landing pages for iframe
  includeMaxMortgageLanding: '/includes/landing-pages/maximale-hypotheek',
  includeRefinanceLanding: '/includes/landing-pages/oversluiten',
  includeIncreaseLanding: '/includes/landing-pages/verhogen',
  includeRouterLanding: '/includes/landing-pages/router',
});
